"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var LayoutRow = function LayoutRow(_ref) {
    var label = _ref.label, value = _ref.value, className = _ref.className, href = _ref.href, target = _ref.target, rel = _ref.rel;
    return /*#__PURE__*/ react_1.default.createElement(Row, {
        className: className
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Padding, {
        halfPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(Label, {
        dangerouslySetInnerHTML: {
            __html: label
        }
    })), /*#__PURE__*/ react_1.default.createElement(atoms_1.Padding, {
        halfPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(ValueWrapper, null, !href && /*#__PURE__*/ react_1.default.createElement(ValueBlock, {
        dangerouslySetInnerHTML: {
            __html: value
        }
    }), !!href && /*#__PURE__*/ react_1.default.createElement(ValueLink, {
        href: href,
        rel: rel,
        target: target || "",
        dangerouslySetInnerHTML: {
            __html: value
        }
    }), /*#__PURE__*/ react_1.default.createElement(Underline, null))));
}; // Styling
var Row = styled_components_1.default.div.withConfig({
    displayName: "LayoutRow__Row",
    componentId: "sc-1wn62e2-0"
})(["display:flex;flex-direction:row;justify-content:space-between;flex-wrap:wrap;", " ", "{flex-wrap:nowrap;}"], _theme_1.type.p, _utils_1.mediaQuery('tablet'));
var ValueWrapper = styled_components_1.default.div.withConfig({
    displayName: "LayoutRow__ValueWrapper",
    componentId: "sc-1wn62e2-1"
})(["position:relative;display:inline-block;"]);
var rowStyle = styled_components_1.css(["&::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.3) * 1em);}&::after{margin-bottom:calc((1 - 1.55) * 1em);}", "{margin-bottom:calc((1 - 1.5) * 1em);}"], _utils_1.mediaQuery('desktop'));
var Label = styled_components_1.default.div.withConfig({
    displayName: "LayoutRow__Label",
    componentId: "sc-1wn62e2-2"
})([""]);
var ValueBlock = styled_components_1.default.div.withConfig({
    displayName: "LayoutRow__ValueBlock",
    componentId: "sc-1wn62e2-3"
})(["color:", ";", ""], _theme_1.palette.brown, rowStyle);
var ValueLink = styled_components_1.default.a.withConfig({
    displayName: "LayoutRow__ValueLink",
    componentId: "sc-1wn62e2-4"
})(["color:", ";", ""], _theme_1.palette.brown, rowStyle);
var Underline = styled_components_1.default.div.withConfig({
    displayName: "LayoutRow__Underline",
    componentId: "sc-1wn62e2-5"
})(["display:none;", "{position:absolute;bottom:-12px;display:block;width:100%;height:1px;&::after{position:absolute;top:0;bottom:0;left:0;right:0;background-color:", ";transform-origin:center bottom;transform:scaleX(0);transition:transform 0.4s ease-in-out;will-change:transform;content:'';}", ":hover &::after{transform-origin:center top;transform:scaleX(1);}}"], _utils_1.mediaQuery('tablet'), _theme_1.palette.brown, ValueWrapper); // Typing
exports.default = LayoutRow;
